import { useLanguage } from "./LanguageProvider";
import MKTypography from "../components/MKTypography";
import { Box } from "@mui/material";

const flagEmojis = {
  nl: "🇳🇱",
  en: "🇬🇧",
};

function LanguageSwitch() {
  const { language, setLanguage, supportedLanguages } = useLanguage();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
      }}
    >
      {supportedLanguages.map((lang) => (
        <MKTypography
          key={lang.code}
          component="button"
          variant="button"
          fontWeight={language === lang.code ? "bold" : "regular"}
          color={language === lang.code ? "primary" : "text"}
          sx={{
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: "4px 6px",
            borderRadius: "4px",
            fontSize: "1.25rem",
            lineHeight: 1,
            transition: "all 200ms ease",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.05)",
            },
          }}
          onClick={() => setLanguage(lang.code)}
          title={lang.name}
        >
          {flagEmojis[lang.code]}
        </MKTypography>
      ))}
    </Box>
  );
}

export default LanguageSwitch;
